export const regBoxClicked = {
    event: "reg_box_clicked",
    eventCategory: "sell_car_homepage",
    eventAction: "reg_box_clicked",
    eventLabel: "reg box click"
};

export const confirmCtaClick = {
    event: "confirm_cta_click",
    eventCategory: "sell_car_homepage",
    eventAction: "confirm_cta_click",
    eventLabel: "reg number detail | confirm cta | click"
};

export const regNoEntered =  {
    eventCategory: "homepage_dweb",
    event: "reg_no_entered",
    eventAction: "reg_number_entered"
};

export const repeatInspection = {
    event: "repeat_inspection",
    eventCategory: "repeat_user_reg"
};
